import { render, staticRenderFns } from "./KidjoFaq.vue?vue&type=template&id=d8f5a8e6&scoped=true"
import script from "./KidjoFaq.vue?vue&type=script&lang=js"
export * from "./KidjoFaq.vue?vue&type=script&lang=js"
import style0 from "./KidjoFaq.vue?vue&type=style&index=0&id=d8f5a8e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f5a8e6",
  null
  
)

export default component.exports